const damHistoryType = {
  GET_DAM_HISORIES: 'GET_HISORIES',
  GET_DAM_HISTORY_LIST: 'GET_HISTORY_LIST',
  CLEAR_DAM_REDUCER: 'CLEAR_REDUCER',
};

export default damHistoryType;
